module.exports = __webpack_public_path__ + "img/blueback.f068fa6f.svg";